export default "__VITE_ASSET__48e9b279__"